/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeParagraph, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';

import React, { useContext } from 'react';
import { useQuizProfileController } from '../../../../hooks/controllers/quiz-profile-controller';
import Button from '../button';
import { QuizProfileContext } from './context/QuizContext';
import {
  AligiPageInformations,
  ButtonWrapper,
  Content,
} from './quiz-profile-style';

function FirstPageQuiz() {
  const { handleChangeStep, moduleSettings, user, currentStep, previusStep } =
    useContext(QuizProfileContext);
  const { navigateTo } = Sebrae.useSebraeRouter();

  const { getProfileStepByIdInterview } = useQuizProfileController();

  React.useEffect(() => {
    const url =
      window.location.protocol +
      '//' +
      window.location.host +
      '/candidato/questionario/perfil/interview';

    if (previusStep > 0) return;
    getProfileStepByIdInterview(user?.id)
      .then((response) => {
        if (response !== undefined) {
          const data = response.collaboratorQuestions.filter(
            (it) => it.questionOption?.question?.step?.sequenceStep === 8,
          );

          const elementoMaiorSequenceStep =
            response.collaboratorQuestions?.reduce(
              (max, current) =>
                current.questionOption.question.step.sequenceStep >
                max.questionOption.question.step.sequenceStep
                  ? current
                  : max,
              response.collaboratorQuestions[0],
            );

          if (data.length > 0 || response.statusQuizProfileFinish) {
            navigateTo(`${url}/sucesso`);
          }

          handleChangeStep(
            (prev) =>
              elementoMaiorSequenceStep.questionOption.question.step
                .sequenceStep,
          );
        }
      })
      .catch((error) => {
        console.log('ou', error);
      });
  }, [
    getProfileStepByIdInterview,
    user,
    navigateTo,
    handleChangeStep,
    currentStep,
    previusStep,
  ]);

  const returnTextColorFormated = (text) => {
    return (
      <BaSeParagraph
        isBold
        color={BaSeTheme.colors.institucionais.cinzaSebrae45}
      >
        {text}
      </BaSeParagraph>
    );
  };

  return (
    <>
      <Content>
        <AligiPageInformations>
          <BaSeParagraph
            isBold
            color={BaSeTheme.colors.institucionais.azulSebrae36}
          >
            Seja bem-vindo {user?.candidate?.name}
          </BaSeParagraph>

          {returnTextColorFormated(
            'O seminário a seguir é dividido em duas partes, a primeira é formada por 55 afirmações.',
          )}

          {returnTextColorFormated(
            'Leia cuidadosamente as afirmações e decida qual das alternativas descreve melhor o seu comportamento em cada situação.',
          )}
          {returnTextColorFormated(
            'Seja honesto consigo mesmo – lembre-se de que ninguém faz tudo corretamente, e que nem mesmo é desejável que se saiba fazer tudo.',
          )}
          {returnTextColorFormated(
            'Note que algumas afirmações são similares, mas nenhuma é exatamente igual;',
          )}

          {returnTextColorFormated(
            'A segunda parte é formada por 6 questões que irão tentar descobrir o seu perfil dentro da sua startup, novamente seja honesto consigo mesmo, isso vai ser importante para você dentro do seminário.',
          )}
        </AligiPageInformations>
      </Content>

      <ButtonWrapper>
        <>
          <Button
            calback={() => {
              handleChangeStep((prev) => prev + 1);
            }}
            value={'AVANÇAR'}
            valueSmall={'AVANÇAR'}
            withBorder={true}
            color={moduleSettings?.tertiaryColor}
            borderColor={moduleSettings?.primaryColor}
          />
        </>
      </ButtonWrapper>
    </>
  );
}
export default FirstPageQuiz;
